import { APIClient } from "../helpers/api_helper";
import * as url from "../helpers/url_helper";

const api = new APIClient();

export const getAllUserListService = (params = {}) => {
  return api.get(url.GET_USER_LIST, params);
};

export const getUserDetailsService = (id) => {
  return api.get(url.GET_USER(id));
};

export const deleteUserService = (id) => {
  return api.delete(url.DELETE_USER(id));
};

export const updateUserStatusService = (id, status) => {
  return api.put(url.PUT_USER_STATUS(id, status));
};
